import Vue from 'vue'
import VueRouter from 'vue-router'
import transactionRecordsRoute from './routes/transactionRecords'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/index/Index.vue')
  },
  {
    path: '/game',
    name: 'GameCategory',
    component: () => import('@/views/game/GameCategory.vue')
  },
  {
    path: '/gameFrame',
    name: 'GameFrame',
    component: () => import('@/views/game/GameFrame.vue')
  },
  {
    path: '/activity',
    name: 'Activity',
    component: () => import('@/views/activity/Activity.vue')
  },
  {
    path: '/service',
    name: 'Service',
    component: () => import('@/views/service/Service.vue')
  },
  {
    path: '/rtp',
    name: 'Rtp',
    alias: '/rtp/',
    component: () => import('@/views/rtp/rtp.vue')
  },
  {
    path: '/cooperate',
    name: 'Cooperate',
    component: () => import('@/views/service/Cooperate.vue')
  },
  {
    path: '/mine',
    name: 'Mine',
    component: () => import('@/views/mine/Mine.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/about/About.vue')
  },
  {
    path: '/deposit',
    name: 'Deposit',
    component: () => import('@/views/deposit/Deposit.vue')
  },
  {
    path: '/withdrawal',
    name: 'Withdrawal',
    component: () => import('@/views/withdrawal/Withdrawal.vue')
  },
  {
    path: '/gameRules',
    name: 'GameRules',
    component: () => import('@/views/gameRules/GameRules.vue')
  },
  {
    path: '/oddsRules',
    name: 'OddsRules',
    component: () => import('@/views/oddsRules/OddsRules.vue')
  },
  {
    path: '/personalData',
    name: 'PersonalData',
    component: () => import('@/views/personalData/PersonalData.vue')
  },
  {
    path: '/paymentMethod',
    name: 'PaymentMethod',
    component: () => import('@/views/paymentMethod/PaymentMethod.vue')
  },
  {
    path: '/accountsAndSecurity',
    name: 'AccountsAndSecurity',
    component: () => import('@/views/accountsAndSecurity/AccountsAndSecurity.vue')
  },
  {
    ...transactionRecordsRoute
  },
  {
    path: '/betRecords',
    name: 'BetRecords',
    component: () => import('@/views/betRecords/BetRecords.vue')
  },
  {
    path: '/myRecommend',
    name: 'MyRecommend',
    component: () => import('@/views/myRecommend/MyRecommend.vue')
  },
  {
    path: '/myKYC',
    name: 'MyKYC',
    component: () => import('@/views/myKYC/MyKYC.vue')
  },
  {
    path: '/myMessage',
    name: 'MyMessage',
    component: () => import('@/views/myMessage/MyMessage.vue')
  },
  {
    path: '/myFeedback',
    name: 'MyFeedback',
    component: () => import('@/views/myFeedback/MyFeedback.vue')
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register/Register.vue')
  },
  {
    path: '/forget',
    name: 'Forget',
    component: () => import('@/views/forget/Forget.vue')
  }
  

]

const router = new VueRouter({
  routes
})

export default router
